module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0.001,"color":"#198CDB","label":"<=0.04"},{"quantity":0.03,"color":"#91E3AD","label":"0.04-0.31"},{"quantity":0.06,"color":"#DEFFB0","label":"0.31- 0.81"},{"quantity":0.1,"color":"#FFE68C","label":"0.81-1.60"},{"quantity":9,"color":"#FF9982","label":"1.60-2.85"},{"quantity":12,"color":"#FF4D30","label":">2.85"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_80_maize.json
// module id = tjAX
// module chunks = 171